<template>
    <div ref="chartContainer">
        <highcharts v-if="Object.keys(chartData).length" :options="chartData" ref="chart" />
    </div>
</template>
<script>
export default {
    name: "StackChart",
    props: {
        rawData: {
            type: Object,
            required: true
            /* 
                categories: [],
                seriesData: [
                    {
                        name: "Neutral",
                        data: [],
                        color: "#B3B2B9",
                        marker: {
                            states: {
                                hover: {
                                    radiusPlus: 5,
                                    lineWidthPlus: 3,
                                },
                            },
                        },
                    },
                ]
            */
        }
    },
    data() {
        return {
            chartData: {},
        }
    },
    mounted() {
        if (this.rawData.seriesData.length) {
            this.plotChart();
        }
        this.resizeObserver = new ResizeObserver(() => {
            this.resizeChart();
        });
        this.resizeObserver.observe(this.$refs.chartContainer);
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },
    watch: {
        rawData: {
            handler() {
                this.plotChart()
            },
            deep: true
        }
    },
    methods: {
        resizeChart() {
            if (this.$refs.chart.chart) {
                this.$refs.chart.chart.reflow();
            }
        },
        plotChart() {
            let self = this;

            let plotSeriesData = this.rawData.seriesData.map(series => {
                return {
                    name: series.name,
                    data: series.data,
                    color: series.color,
                    borderRadiusTopLeft: series.borderRadius,
                    borderRadiusTopRight: series.borderRadius,
                    marker: {
                        states: {
                            hover: {
                                radiusPlus: 5,
                                lineWidthPlus: 3,
                            },
                        },
                    },
                }
            });

            this.chartData = {
                chart: {
                    type: "column",
                    height: "400"
                },
                title: {
                    text: "",
                },
                credits: {
                    enabled: false,
                },
                exporting: {
                    enabled: false,
                },
                xAxis: {
                    categories: self.rawData.categories,
                    labels: {
                        style: {
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            fontWeight: '400',
                            lineHeight: '16px',
                            textAlign: 'center',
                            color: '#000000',
                            textTransform: 'capitalize'
                        },
                        y: 30,
                    },
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "",
                    },
                    stackLabels: {
                        enabled: false,
                    },
                    visible: true,
                    lineWidth: 1,
                    labels: {
                        style: {
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            fontWeight: '500',
                            lineHeight: '16px',
                            textAlign: 'center',
                            color: '#A1A1A1'
                        },
                    },
                    gridLineColor: '#E4EDEE',
                    gridLineWidth: 1.5,
                    gridLineDashStyle: 'Dash'
                },
                legend: {
                    verticalAlign: 'top',
                    align: 'right',
                    symbolHeight: 10,
                    itemStyle: {
                        fontSize: '14px',
                        textTransform: 'capitalize'
                    },
                },
                tooltip: {
                    formatter() {
                        var mytooltip = this.point.category + "<br/>";
                        mytooltip +=
                            '<span style="color:' + this.point.series.color + '">\u25CF</span> ';
                        mytooltip += this.point.series.name;
                        mytooltip +=
                            " : <b> " +
                            this.point.y +
                            " (" +
                            this.point.percentage.toFixed(2) +
                            "%)</b> <br/>";
                        mytooltip += "Total: <b>" + this.point.total + "</b>";
                        return mytooltip;
                    },
                    borderWidth: 0,
                    shadow: {
                        color: "#d6d6d6",
                        opacity: 0.1,
                        width: 10,
                    },
                    borderRadius: 6,
                    backgroundColor: "#ffffff",
                },
                plotOptions: {
                    column: {
                        stacking: "normal",
                        borderWidth: 0,
                        dataLabels: {
                            enabled: false,
                        },
                    },
                },
                series: plotSeriesData
            }
        }
    }
}
</script>